import { jsx } from "react/jsx-runtime";
import VpnKeyOffIcon from "@mui/icons-material/VpnKeyOff";
import { validateTidalLicense } from "../../base/index.js";
function VpnKeyOff(props) {
  return /* @__PURE__ */ jsx(
    VpnKeyOffIcon,
    {
      "data-testid": "VpnKeyOff",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "VpnKeyOff",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
VpnKeyOff.tidalIconMeta = {
  categories: "miscellaneous",
  name: "VpnKeyOff"
};
validateTidalLicense();
export {
  VpnKeyOff
};
//# sourceMappingURL=VpnKeyOff.js.map
